import { navigateTo } from 'nuxt/app'
import { useUsersStore } from '~/stores/users'

export default defineNuxtRouteMiddleware((to) => {
  const userStore = useUsersStore()

  if (import.meta.client && to.name === 'account-hulpvragen') {
    if (userStore.specificUser?.cook) {
      return navigateTo({ name: 'account' })
    }
  }
})
